import React, { useState, useEffect } from "react";
import { useGetOpportunityInfoGather } from "@/api/opportunities/useGetOpportunityInfoGather";
import { toast } from "react-toastify";
import { apiRequest } from "@/network/apiClient";
import { useGetAccountOwner } from "@/api/auth/useGetAccountOwner";
import { useHunterFarmerList } from "@/api/auth/useHunterFarmerList";
import { API_ENDPOINTS } from "@/api/apiEndpoints";
import { LeadJourneyDetailsSkeleton } from "../lead-journey/skeleton/LeadJourneySkeleton";
import { regionCountryMap } from '../../components/Constants.jsx';
import { correlationHeaders } from "@/utils/correlationId";

const BASE_URL = import.meta.env.VITE_BASE_URL;

const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    const headers = { "Content-Type": "application/json", ...correlationHeaders() };
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
  };

const selectClass = (value, base = "") =>
  `${base} ${!value ? "text-gray-400" : "text-black"}`;

const OpportunityInfoTab = ({ funnel, oppID, oppData }) => {
    const getAuthHeaders = () => {
        const token = localStorage.getItem("token");
        const headers = { "Content-Type": "application/json", ...correlationHeaders() };
        if (token) headers.Authorization = `Bearer ${token}`;
        return headers;
      };
      
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingBankDetails, setIsEditingBankDetails] = useState(false);
  const [showAssignHunter, setShowAssignHunter] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showReferralConfirmationModal, setShowReferralConfirmationModal] = useState(false);
  const [showFinancingConfirmationModal, setShowFinancingConfirmationModal] = useState(false)
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(null)
  const [showBankDetailsConfirmationModal, setShowBankDetailsConfirmationModal] = useState(false);
  const [selectedHunter, setSelectedHunter] = useState("")
  const [isLoadingReferral, setIsLoadingReferral] = useState(false);
  const role = localStorage.getItem("role");
  const canEditLead = role === 'Admin';

  // Lead / referral journey
  const [leadJourney, setLeadJourney] = useState({});
  const [referralFormData, setReferralFormData] = useState({
    race_of_pic_others: "",
    user_id: null,
  });

  // Financing info
  const [financingFormData, setFinancingFormData] = useState({
    type: "Invoice",
    type_other: "",
    partner: "Capbay",
    partner_other: "",
    requested_amt: "",
    products_id: null,
    status: 3,
  });

  // Insurance info
  const [insuranceData, setInsuranceData] = useState(null);
  const [isLoadingInsurance, setIsLoadingInsurance] = useState(false);

  // Referrer bank details
  const [referrerData, setReferrerData] = useState(null);
  const [isLoadingReferrer, setIsLoadingReferrer] = useState(false);

  const [userId, setUserId] = useState(null);

  const { oppDetails, refetch } = useGetOpportunityInfoGather({oppID, funnel});

  const lead_id = oppData?.lead_id;
  const referredLeadID = oppData?.referred_lead_id
  const accountOwner = useGetAccountOwner({leadID: referredLeadID})
  const [showAssignHunterConfirmationModal, setShowAssignHunterConfirmationModal] = useState(false);
  const{hunterListAPI} = useHunterFarmerList()

  const isReferralFunnel = oppData?.funnel === "Referral";
  const isFinancingFunnel = funnel === "Financing";
  const isInsuranceFunnel =
    funnel === "Insurance" || funnel === "InsuranceRenewal";

  // --------- Referral Related -------------
  const relationshipStrengthMap = {
    1: {
      label: "Cold",
      icon: <img src="/icons/cold.svg" className="size-8 -mt-1" />,
    }, // Cold
    2: {
      label: "Warm",
      icon: <img src="/icons/warm.svg" className="size-8 -mt-1" />,
    }, // Warm
    3: {
      label: "Hot",
      icon: <img src="/icons/hot.svg" className="size-8 -mt-1" />,
    }, // Hot
  };

  const contactMethodMap = {
    EVENT_IN_PERSON: "Event/In-person",
    CALL: "Call",
    TEXT_MESSAGE: "Text/Message",
    EMAIL: "E-mail",
    SOCIAL_MEDIA: "Social Media",
  };

  const relationshipStrengthSelectMap = {
    "Cold" : "Cold",
    "Warm" : "Warm",
    "Hot" : "Hot",
  };

  // Map between numeric API values and string dropdown values
  const relationshipStrengthNumericMap = {
    1: "Cold",
    2: "Warm",
    3: "Hot",
  };

  const relationshipStrengthStringToNumericMap = {
    "Cold": 1,
    "Warm": 2,
    "Hot": 3,
  };

  const raceOfPicMap = {
    Malay: "Malay",
    Chinese: "Chinese",
    Indian: "Indian",
    Others: "Others",
  };

  const languageMap = {
    BAHASA_MALAYSIA: "Bahasa Malaysia",
    ENGLISH: "English",
    MANDARIN: "Mandarin",
    CANTONESE: "Cantonese",
    HOKKIEN: "Hokkien",
    TAMIL: "Tamil",
  };

  const salutationMap = {
    MR: "Mr.",
    MS: "Ms.",
    MRS: "Mrs.",
  };

  const industryMap = {
    "Agriculture": "Agriculture",
    "Art, Entertainment and Recreation": "Art, Entertainment and Recreation",
    "Automotives & Motorcycles": "Automotives & Motorcycles",
    "Beauty & Wellness": "Beauty & Wellness",
    "Building Cleaning, Pest Control & Gardening Services": "Building Cleaning, Pest Control & Gardening Services",
    "Charity & Voluntary work": "Charity & Voluntary work",
    "Computer Hardware / Software / Electronic Devices": "Computer Hardware / Software / Electronic Devices",
    "Construction": "Construction",
    "Customized Gifts / Souvenirs / Printing": "Customized Gifts / Souvenirs / Printing",
    "Employment Related": "Employment Related",
    "Event Management": "Event Management",
    "Fabric, Apparel & Accessories": "Fabric, Apparel & Accessories",
    "Family & Baby": "Family & Baby",
    "Finance / Investment / Wealth Management": "Finance / Investment / Wealth Management",
    "Food & Beverages - Product": "Food & Beverages - Product",
    "Food and Beverages - Service": "Food and Beverages - Service",
    "Healthcare": "Healthcare",
    "Home Furniture & Hardware Appliances": "Home Furniture & Hardware Appliances",
    "Hospitality / Travel": "Hospitality / Travel",
    "Industrial Goods": "Industrial Goods",
    "Information Technology": "Information Technology",
    "Logistics": "Logistics",
    "Machinery": "Machinery",
    "Management / Administrative": "Management / Administrative",
    "Media / Marketing": "Media / Marketing",
    "Medical & Pharmaceuticals": "Medical & Pharmaceuticals",
    "Oil & Gas": "Oil & Gas",
    "Pets Supplies": "Pets Supplies",
    "Real Estate": "Real Estate",
    "Regulatory (Legal / Accounting)": "Regulatory (Legal / Accounting)",
    "Research / Consultancy": "Research / Consultancy",
    "Religious Services": "Religious Services",
    "Sales": "Sales",
    "Science & Education": "Science & Education",
    "Security": "Security",
    "Sports, Hobbies & Recreation": "Sports, Hobbies & Recreation",
    "Telecommunications": "Telecommunications",
    "Transportation": "Transportation",
    "Weapons / Defence / Aerospace": "Weapons / Defence / Aerospace",
    "Others": "Others",
  };

  const natureOfBusinessMap = {
    "Agencies / Intermediaries / other services": "Agencies / Intermediaries / other services",
    "Distributor": "Distributor",
    "Manufacturing": "Manufacturing",
    "Non-Profit": "Non-Profit",
    "Professional Services": "Professional Services",
    "Retail": "Retail",
    "Trading": "Trading",
  };

  const bankNameList = [
    "Affin Bank Berhad",
    "Al Rajhi Bank",
    "Alliance Bank Malaysia",
    "Ambank (M) Berhad",
    "Bank Islam Malaysia Berhad",
    "CIMB Bank Berhad",
    "CIMB Islamic Bank Berhad",
    "Citibank Berhad",
    "Easypay",
    "Hawala",
    "Hong Leong Bank Berhad",
    "HSBC Bank Malaysia Berhad",
    "Instarem",
    "Kuwait Finance House (Malaysia) Berhad",
    "Malayan Banking Berhad",
    "Maybank Islamic Berhad",
    "MerchantTrade",
    "None",
    "OCBC Alamin Bank Berhad",
    "OCBC Bank (Malaysia) Berhad",
    "Public Bank Berhad",
    "RHB Bank Berhad",
    "Standard Chartered Bank Malaysia Berhad",
    "United Overseas Bank (Malaysia) Berhad",
    "Western Union",
    "Others",
  ];

  const countryCodes = [
    { value: "+60", label: "+60 (Malaysia)" },
    { value: "+65", label: "+65 (Singapore)" },
    { value: "+62", label: "+62 (Indonesia)" },
    { value: "+66", label: "+66 (Thailand)" },
    { value: "+63", label: "+63 (Philippines)" },
    { value: "+84", label: "+84 (Vietnam)" },
    { value: "+1", label: "+1 (US/Canada)" },
    { value: "+44", label: "+44 (UK)" },
    { value: "+61", label: "+61 (Australia)" },
    { value: "+86", label: "+86 (China)" },
    { value: "+91", label: "+91 (India)" },
    { value: "+81", label: "+81 (Japan)" },
    { value: "+82", label: "+82 (South Korea)" },
    { value: "+852", label: "+852 (Hong Kong)" },
    { value: "+853", label: "+853 (Macau)" },
  ];

  const handleRelationshipStrengthChange = (e) => {
    const stringValue = e.target.value; // Get string value from dropdown
    const numericValue = relationshipStrengthStringToNumericMap[stringValue]; // Convert to numeric for API
    setReferralFormData((prevState) => ({
      ...prevState,
      interest_level: numericValue,
    }));
  };

  const handleLanguageChange = (languageKey) => {
    setReferralFormData((prevState) => {
      const currentLanguages = prevState.languages || [];
      const isSelected = currentLanguages.includes(languageKey);
      
      let updatedLanguages;
      if (isSelected) {
        updatedLanguages = currentLanguages.filter(lang => lang !== languageKey);
      } else {
        updatedLanguages = [...currentLanguages, languageKey];
      }
      
      return {
        ...prevState,
        languages: updatedLanguages,
      };
    });
  };
  const relationshipStrength = leadJourney.interest_level;
  const { label, icon } = relationshipStrengthMap[relationshipStrength] || { label: "Unknown", icon: "❓" };

    // Helper function to parse mobile number into country code and number
  const parseMobileNumber = (mobileNo) => {
    if (!mobileNo) return { countryCode: "+60", number: "" };
    
    // Try to find a matching country code
    for (const code of countryCodes) {
      if (mobileNo.startsWith(code.value)) {
        return {
          countryCode: code.value,
          number: mobileNo.substring(code.value.length).trim(),
        };
      }
    }
    
    // Default to Malaysia if no match found
    return { countryCode: "+60", number: mobileNo };
  };

  const parseLanguages = (languageString) => {
    if (!languageString) return [];
    const languages = languageString.split(',').map(lang => lang.trim()).filter(lang => lang);
    
    return languages.map(lang => {
      if (languageMap[lang]) {
        return lang;
      }
      const enumKey = Object.keys(languageMap).find(key => languageMap[key] === lang);
      return enumKey || lang; // Return enum key if found, otherwise keep original
    });
  };

  const languagesToString = (languages) => {
    if (!languages || languages.length === 0) return "";
    return languages.map(key => languageMap[key] || key).join(', ');
  };



  // ---------- Formatters ----------
  const formatCurrency = (value) => {
    if (value === null || value === undefined || isNaN(parseFloat(value))) {
      return "0.00";
    }
    return parseFloat(value).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatInsuranceType = (type) => {
    if (!type) return "";
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  // ---------- Load userId from localStorage ----------
  useEffect(() => {
    const storedUserId = Number(localStorage.getItem("userId"));
    if (!isNaN(storedUserId)) {
      setUserId(storedUserId);
      setReferralFormData((prev) => ({
        ...prev,
        user_id: storedUserId,
      }));
    }
  }, []);

  // ---------- Fetch lead / referral journey data (only based on funnel) ----------
  useEffect(() => {
    if (!oppData?.lead_id) return;
    const fetchReferralJourney = async () => {
      setIsLoadingReferral(true)
      try {
        const result = await apiRequest(`${BASE_URL}/opp_referral_details?lead_id=${referredLeadID}`, 'GET');
        if (!result) throw new Error("Failed to fetch referral details");
        setLeadJourney(result);
        const parsedMobile = parseMobileNumber(result.mobile_no);
        const parsedLanguages = parseLanguages(result.language);
        setReferralFormData((prev) => ({
          ...prev,
          ...result,
          mobile_country_code: parsedMobile.countryCode,
          mobile_no: parsedMobile.number,
          languages: parsedLanguages,
        }));
      } catch (err) {
        console.error("Error fetching referral details:", err);
        toast.error("Failed to load referral details");
      } finally {
        setIsLoadingReferral(false)
      }
    };
    const fetchLeadJourney = async () => {
      try {
        const result = await apiRequest(`${BASE_URL}/lead_journey_tbl?lead_id=${oppData.lead_id}`, 'GET');
        if (!result) throw new Error("Failed to fetch lead journey");
        setLeadJourney(result);
        const parsedMobile = parseMobileNumber(result.mobile_no);
        const parsedLanguages = parseLanguages(result.language);
        setReferralFormData((prev) => ({
          ...prev,
          ...result,
          mobile_country_code: parsedMobile.countryCode,
          mobile_no: parsedMobile.number,
          languages: parsedLanguages,
        }));
      } catch (err) {
        console.error("Error fetching lead journey:", err);
        toast.error("Failed to load lead journey");
      }
    };

    if (isReferralFunnel && referredLeadID) {  
      // Referral → use opp_referral_details
      fetchReferralJourney();
    } else if (!isFinancingFunnel && !isInsuranceFunnel) {
      // Only non-Financing / non-Insurance funnels should call lead_journey_tbl
      fetchLeadJourney();
    }
  }, [oppData?.lead_id, referredLeadID, isReferralFunnel, isFinancingFunnel, isInsuranceFunnel]);

  const handleHunterAssignSubmit = () => {
    // Find the selected hunter's details from hunterList
    const selectedHunterDetails = hunterListAPI.find(
      (h) => h.username === selectedHunter
    );
    if (selectedHunterDetails) {
      // Update referralFormData with the selected hunter's id and username
      setReferralFormData((prevState) => ({
        ...prevState,
        hunter_id: selectedHunterDetails.id,
        hunter_name: selectedHunterDetails.username,
      }));
    }

    setShowAssignHunter(false); // Close the assign modal
    setShowAssignHunterConfirmationModal(false)
    setShowReferralConfirmationModal(true); // Show the confirmation modal
  };

  // ---------- Populate financing form from oppDetails ----------
  useEffect(() => {
    if (!isFinancingFunnel || !oppDetails) return;

    setFinancingFormData((prev) => ({
      ...prev,
      type: oppDetails.type || "Invoice",
      type_other: oppDetails.type_other || "",
      partner: oppDetails.partner || "Capbay",
      partner_other: oppDetails.partner_other || "",
      requested_amt:
      oppDetails.requested_amt === null || oppDetails.requested_amt === undefined
      ? ""
      : String(oppDetails.requested_amt),
      products_id: oppDetails?.products_id ?? prev.products_id,
      status: 3,
    }));
  }, [isFinancingFunnel, oppDetails]);

  // ---------- Fetch insurance data (Insurance / InsuranceRenewal) ----------
  useEffect(() => {
    const refId = oppData?.ref_id;
    if (!isInsuranceFunnel || !refId) return;

    const fetchInsuranceData = async () => {
      setIsLoadingInsurance(true);
      try {
        const response = await fetch(`${BASE_URL}/get_insur_api/${refId}`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          console.error("Failed to fetch insurance data");
          toast.error("Failed to fetch insurance data");
          return;
        }
        const data = await response.json();
        setInsuranceData(data);
      } catch (error) {
        console.error("Error fetching insurance data:", error);
        toast.error("Error fetching insurance data");
      } finally {
        setIsLoadingInsurance(false);
      }
    };

    fetchInsuranceData();
  }, [isInsuranceFunnel, oppData?.ref_id]);

  // ---------- Fetch referrer bank details (Referral only) ----------
  useEffect(() => {
    if (!isReferralFunnel || !referredLeadID) return;

    const fetchReferrerData = async () => {
      setIsLoadingReferrer(true);
      try {
        const result = await apiRequest(
          `${BASE_URL}/${API_ENDPOINTS.REFERRER.GET}?lead_id=${oppData.lead_id}`,
          'GET'
        );
        if (result) {
          setReferrerData(result);
          // Also update referralFormData with bank details
          setReferralFormData((prev) => ({
            ...prev,
            bank_name: result.bank_name || "",
            bank_acc_name: result.bank_acc_name || "",
            bank_acc_no: result.bank_acc_no || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching referrer data:", error);
        // Don't show error toast if referrer doesn't exist yet (404 is expected)
        if (error?.status !== 404) {
          toast.error("Failed to load referrer bank details");
        }
      } finally {
        setIsLoadingReferrer(false);
      }
    };

    fetchReferrerData();
  }, [isReferralFunnel, oppData?.lead_id]);

  // ---------- Handlers ----------
  const handleCancel = () => {
    // Reset financing form from oppDetails
    if (isFinancingFunnel && oppDetails) {
      setFinancingFormData({
        type: oppDetails.type || "Invoice",
        type_other: oppDetails.type_other || "",
        partner: oppDetails.partner || "Capbay",
        partner_other: oppDetails.partner_other || "",
        requested_amt: oppDetails.requested_amt || 0,
        products_id: oppDetails?.products_id,
        status: 3,
      });
    }
    // Reset referral form from leadJourney
    if (leadJourney && Object.keys(leadJourney).length > 0) {
      const parsedMobile = parseMobileNumber(leadJourney.mobile_no);
      const parsedLanguages = parseLanguages(leadJourney.language);
      setReferralFormData((prev) => ({
        ...prev,
        ...leadJourney,
        mobile_country_code: parsedMobile.countryCode,
        mobile_no: parsedMobile.number,
        languages: parsedLanguages,
        // Reset bank details from referrerData if available
        bank_name: referrerData?.bank_name || "",
        bank_acc_name: referrerData?.bank_acc_name || "",
        bank_acc_no: referrerData?.bank_acc_no || "",
      }));
    }
    setIsEditing(false);
  };

  const handleEditClick = () => {
    setIsEditing((prev) => !prev);
  };

  const handleSubmit = () => {
    if(isReferralFunnel){
      setShowReferralConfirmationModal(true);
    } else if (isFinancingFunnel){
      setShowFinancingConfirmationModal(true)
    }
  };

  const handleConfirmationCancel = () => {
    setShowReferralConfirmationModal(false);
    setShowAssignHunterConfirmationModal(false);
    setShowFinancingConfirmationModal(false)
    setIsEditing(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (
      isFinancingFunnel &&
      ["type", "type_other", "partner", "partner_other", "requested_amt"].includes(
        name
      )
    ) {
      setFinancingFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else {
      setReferralFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };  

  const handleFinancingConfirmationSubmit = async () => {
    try {
      const payload = {
        ...financingFormData,
        // convert to number here, default 0 if blank
        requested_amt:
          financingFormData.requested_amt === "" ||
          financingFormData.requested_amt === null ||
          financingFormData.requested_amt === undefined
            ? 0
            : Number(financingFormData.requested_amt),
      };
  
      const response = await fetch(
        `${BASE_URL}/opp_insert_detail/${funnel}?opp_id=${oppID}`,
        {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify({
            oppID,
            ...payload,
          }),
        }
      );
  
      setIsEditing(false);
      refetch();
      toast.success("Opportunity updated successfully!");

    } catch (error) {
      console.error("Error updating opportunity:", error);
      toast.error("Error updating opportunity");
    } finally {
      setSubmissionLoading(false)
      setShowFinancingConfirmationModal(false)
    }
  };  

  const handleUpdateReferralInfoGathering = async () => {
    setIsLoadingReferral(true)
    setSubmissionLoading(true)
    try {
      // Validate email using HTML5 validation
      if (referralFormData.email) {
        const emailInput = document.querySelector('input[name="email"]');
        if (emailInput && !emailInput.validity.valid) {
          emailInput.reportValidity();
          return;
        }
      }
      
      // Determine the lead_id to use
      const targetLeadId = isReferralFunnel && referredLeadID
        ? referredLeadID
        : lead_id;

      if (!targetLeadId) {
        toast.error("Missing lead ID");
        return;
      }

      // Combine mobile country code and number before sending
      // Convert languages array to comma-separated string
      const submitData = {
        ...referralFormData,
        mobile_no: referralFormData.mobile_country_code && referralFormData.mobile_no 
          ? `${referralFormData.mobile_country_code}${referralFormData.mobile_no}` 
          : referralFormData.mobile_no,
        language: languagesToString(referralFormData.languages || []),
      };
      delete submitData.mobile_country_code;
      delete submitData.languages;
      
      // Use update_lead_journey endpoint (same as LeadJourneyDetails)
      const result = await apiRequest(
        `${BASE_URL}/${API_ENDPOINTS.UPDATE_LEADS.LEAD_JOURNEY}?lead_id=${targetLeadId}`,
        'POST',
        submitData
      );

      if (result) {
        setIsEditing(false);
        
        // Refresh journey data
        let refResult;
        if (isReferralFunnel && referredLeadID) {
          refResult = await apiRequest(`${BASE_URL}/opp_referral_details?lead_id=${referredLeadID}`, 'GET');
        } else {
          refResult = await apiRequest(`${BASE_URL}/lead_journey_tbl?lead_id=${lead_id}`, 'GET');
        }
        
        if (refResult) {
          setLeadJourney(refResult);
          const parsedMobile = parseMobileNumber(refResult.mobile_no);
          const parsedLanguages = parseLanguages(refResult.language);
          setReferralFormData((prev) => ({
            ...prev,
            ...refResult,
            mobile_country_code: parsedMobile.countryCode,
            mobile_no: parsedMobile.number,
            languages: parsedLanguages,
          }));
        }
        
      }

    } catch (error) {
      console.error("Error updating lead journey:", error);
      toast.error(error || "Unable to save data");
      setUploadStatus('error')
    } finally {
      setShowReferralConfirmationModal(false);
      setSubmissionLoading(false)
      toast.success("Lead details successfully saved");
      setIsLoadingReferral(false)
    }
  };

  const handleConfirmation = () => {
    if (isFinancingFunnel) {
      setSubmissionLoading(true)
      handleFinancingConfirmationSubmit();
    } else {
      // referral & other lead journey updates
      setSubmissionLoading(true)
      handleUpdateReferralInfoGathering();
    }
  };

  const handleAssignHunter = () => {
    setShowAssignHunter(true); // Show the reassign modal
  };

  // Bank Details handlers
  const handleBankDetailsEditClick = () => {
    // Ensure bank details are synced from referrerData before editing
    if (referrerData) {
      setReferralFormData((prev) => ({
        ...prev,
        bank_name: referrerData.bank_name || "",
        bank_acc_name: referrerData.bank_acc_name || "",
        bank_acc_no: referrerData.bank_acc_no || "",
      }));
    }
    setIsEditingBankDetails(true);
  };

  const handleBankDetailsCancel = () => {
    setIsEditingBankDetails(false);
    // Reset bank details from referrerData if available
    if (referrerData) {
      setReferralFormData((prev) => ({
        ...prev,
        bank_name: referrerData.bank_name || "",
        bank_acc_name: referrerData.bank_acc_name || "",
        bank_acc_no: referrerData.bank_acc_no || "",
      }));
    } else {
      setReferralFormData((prev) => ({
        ...prev,
        bank_name: "",
        bank_acc_name: "",
        bank_acc_no: "",
      }));
    }
  };

  const handleBankDetailsSubmit = () => {
    setShowBankDetailsConfirmationModal(true);
  };

  const handleBankDetailsConfirmationCancel = () => {
    setShowBankDetailsConfirmationModal(false);
    setIsEditingBankDetails(false);
  };

  const handleBankDetailsConfirmation = async () => {
    try {
      if (!isReferralFunnel || !oppData?.lead_id) {
        toast.error("Missing required information");
        return;
      }

      const bankData = {
        bank_name: referralFormData.bank_name || "",
        bank_acc_name: referralFormData.bank_acc_name || "",
        bank_acc_no: referralFormData.bank_acc_no || "",
      };

      // Only create/update if at least one bank field has a value
      if (bankData.bank_name || bankData.bank_acc_name || bankData.bank_acc_no) {
        let referrerResult;
        
        // Check if referrer exists, if not create it, otherwise update it
        if (!referrerData) {
          // Create new referrer with lead_id in the body
          referrerResult = await apiRequest(
            `${BASE_URL}/${API_ENDPOINTS.REFERRER.CREATE}`,
            'POST',
            {
              lead_id: oppData.lead_id,
              ...bankData,
            }
          );
        } else {
          // Update existing referrer
          referrerResult = await apiRequest(
            `${BASE_URL}/${API_ENDPOINTS.REFERRER.UPDATE}?lead_id=${oppData.lead_id}`,
            'PUT',
            bankData
          );
        }
        
        if (referrerResult) {
          // Refetch referrer data to ensure we have the latest values
          try {
            const refreshedData = await apiRequest(
              `${BASE_URL}/${API_ENDPOINTS.REFERRER.GET}?lead_id=${oppData.lead_id}`,
              'GET'
            );
            if (refreshedData) {
              setReferrerData(refreshedData);
              // Update referralFormData with the saved bank details
              setReferralFormData((prev) => ({
                ...prev,
                bank_name: refreshedData.bank_name || "",
                bank_acc_name: refreshedData.bank_acc_name || "",
                bank_acc_no: refreshedData.bank_acc_no || "",
              }));
            } else {
              // Fallback to referrerResult if refetch fails
              setReferrerData(referrerResult);
              setReferralFormData((prev) => ({
                ...prev,
                bank_name: referrerResult.bank_name || "",
                bank_acc_name: referrerResult.bank_acc_name || "",
                bank_acc_no: referrerResult.bank_acc_no || "",
              }));
            }
          } catch (refetchError) {
            console.error("Error refetching referrer data:", refetchError);
            // Fallback to referrerResult if refetch fails
            setReferrerData(referrerResult);
            setReferralFormData((prev) => ({
              ...prev,
              bank_name: referrerResult.bank_name || "",
              bank_acc_name: referrerResult.bank_acc_name || "",
              bank_acc_no: referrerResult.bank_acc_no || "",
            }));
          }
          setIsEditingBankDetails(false);
          toast.success("Referrer bank details successfully saved");
        }
      } else {
        toast.error("Please fill in at least one bank field");
        return;
      }
    } catch (error) {
      console.error("Error creating/updating referrer bank details:", error);
      toast.error(error || "Failed to save referrer bank details");
    } finally {
      setShowBankDetailsConfirmationModal(false);
    }
  };

  // ---------- Render ----------

  if (isReferralFunnel && isLoadingReferral){
    return(
      <LeadJourneyDetailsSkeleton/>
    )
  }
  return (
    <>
      <div className="w-full bg-white p-7 rounded-3xl shadow-lg">
        {/* Financing block (Information Gathering) */}
        {isFinancingFunnel && (
          <>
            <div className="flex justify-between items-start">
              <div className="flex items-center">
                <p className="font-bold text-2xl text-[#1E293B]">
                  Information Gathering
                </p>
              </div>
              <div className="flex space-x-2">
                {isEditing && (
                  <button
                    className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-gray-200 transition flex items-center justify-center w-12 h-12"
                    onClick={handleCancel}
                    aria-label="Cancel Editing"
                    type="button"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18 18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                )}
                <button
                  className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-yellow-300 transition flex items-center justify-center w-12 h-12"
                  onClick={isEditing ? handleSubmit : handleEditClick}
                  aria-label={isEditing ? "Submit" : "Edit Lead"}
                  type="button"
                >
                  {isEditing ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m4.5 12.75 6 6 9-13.5"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Financing Type */}
            <div className="flex items-center mt-5">
              <div className="border-b border-gray-200 pb-2 w-full flex">
                <span className="w-1/5 font-bold text-[#475569]">
                  Financing Type
                </span>
                {isEditing ? (
                  <select
                    name="type"
                    value={financingFormData.type}
                    onChange={handleChange}
                    className="flex-1"
                  >
                    <option value="Invoice">Invoice</option>
                    <option value="Supply Chain">Supply Chain</option>
                    <option value="Working Capital">Working Capital</option>
                    <option value="Others">Others</option>
                  </select>
                ) : (
                  <>
                    <div className="flex-1 text-[#475569]">
                      <span>{oppDetails?.type || ""}</span>
                    </div>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(
                          `${oppDetails?.type || ""}`
                        );
                        toast.success("Copied to clipboard!");
                      }}
                      className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      type="button"
                    >
                      <img src="/icons/content_copy.svg" className="size-6" />
                    </button>
                  </>
                )}
              </div>
            </div>

            {financingFormData.type === "Others" && (
              <div className="flex items-center mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/5 font-bold text-[#475569]">
                    Financing Type (Others)
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="type_other"
                      value={financingFormData.type_other}
                      onChange={handleChange}
                      placeholder="Enter custom financing type"
                      className="flex-1"
                    />
                  ) : (
                    <>
                      <div className="flex-1 text-[#475569]">
                        <span>{oppDetails?.type_other || ""}</span>
                      </div>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `${oppDetails?.type_other || ""}`
                          );
                          toast.success("Copied to clipboard!");
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        type="button"
                      >
                        <img src="/icons/content_copy.svg" className="size-6" />
                      </button>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* Financing Partner */}
            <div className="flex items-center mt-5">
              <div className="border-b border-gray-200 pb-2 w-full flex">
                <span className="w-1/5 font-bold text-[#475569]">
                  Financing Partner
                </span>
                {isEditing ? (
                  <select
                    name="partner"
                    value={financingFormData.partner}
                    onChange={handleChange}
                    className="flex-1"
                  >
                    <option value="Capbay">Capbay</option>
                    <option value="Boost">Boost</option>
                    <option value="Funding Society">Funding Society</option>
                    <option value="Microleap">Microleap</option>
                    <option value="Others">Others</option>
                  </select>
                ) : (
                  <>
                    <div className="flex-1 text-[#475569]">
                      <span>{oppDetails?.partner || ""}</span>
                    </div>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(
                          `${oppDetails?.partner || ""}`
                        );
                        toast.success("Copied to clipboard!");
                      }}
                      className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      type="button"
                    >
                      <img src="/icons/content_copy.svg" className="size-6" />
                    </button>
                  </>
                )}
              </div>
            </div>

            {financingFormData.partner === "Others" && (
              <div className="flex items-center mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/5 font-bold text-[#475569]">
                    Financing Partner (Others)
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="partner_other"
                      value={financingFormData.partner_other}
                      onChange={handleChange}
                      placeholder="Enter custom financing type"
                      className="flex-1"
                    />
                  ) : (
                    <>
                      <div className="flex-1 text-[#475569]">
                        <span>{oppDetails?.partner_other || ""}</span>
                      </div>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `${oppDetails?.partner_other || ""}`
                          );
                          toast.success("Copied to clipboard!");
                        }}
                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        type="button"
                      >
                        <img src="/icons/content_copy.svg" className="size-6" />
                      </button>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* Requested Amount */}
            <div className="flex items-center mt-5">
              <div className="border-b border-gray-200 pb-2 w-full flex">
                <span className="w-1/5 font-bold text-[#475569]">
                  Requested Amount
                </span>
                {isEditing ? (
                  <div className="flex-1 flex items-center">
                    <span className="text-[#475569] mr-2">MYR</span>
                    <input
                      type="number"
                      name="requested_amt"
                      value={financingFormData.requested_amt}
                      onChange={handleChange}
                      className="flex-1"
                    />
                  </div>
                ) : (
                  <>
                    <div className="flex-1 text-[#475569]">
                      <span>
                        MYR{" "}
                        {formatCurrency(oppDetails?.requested_amt || 0)}
                      </span>
                    </div>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(
                          `MYR ${formatCurrency(
                            oppDetails?.requested_amt || 0
                          )}`
                        );
                        toast.success("Copied to clipboard!");
                      }}
                      className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      type="button"
                    >
                      <img src="/icons/content_copy.svg" className="size-6" />
                    </button>
                  </>
                )}
              </div>
            </div>
          </>
        )}

        {/* Insurance block */}
        {isInsuranceFunnel && (
          <div className="mt-4 flex flex-col gap-4 bg-white rounded-lg">
            {isLoadingInsurance ? (
              <div className="flex justify-center items-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <span className="ml-2 text-[#475569]">Loading</span>
              </div>
            ) : (
              <table className="min-w-full bg-white border-b border-gray-200 rounded-lg table-fixed text-sm">
                <thead>
                  <tr className="text-[#94A3B8] bg-[#E2E8F0]">
                    <th className="p-4 border-b text-start w-[20%]">
                      Insurance Covered
                    </th>
                    <th className="p-4 border-b text-start w-[40%]">
                      Insurance Provider
                    </th>
                    <th className="p-4 border-b text-start w-[20%]">
                      Policy Expires
                    </th>
                    <th className="p-4 border-b text-start w-[20%]">
                      Current Sum Insured
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {insuranceData?.hasExistingPolicy ? (
                    Array.isArray(insuranceData.existingPolicy) ? (
                      insuranceData.existingPolicy.map((policy, index) => (
                        <tr
                          key={`insurance-row-${index}`}
                          className="hover:bg-gray-50"
                        >
                          <td className="p-4 border-b text-[#475569]">
                            {formatInsuranceType(insuranceData.insuranceType)}
                          </td>
                          <td className="p-4 border-b text-[#475569]">
                            {policy.provider}
                          </td>
                          <td className="p-4 border-b text-[#475569]">
                            {policy.policyExpireAt}
                          </td>
                          <td className="p-4 border-b text-[#475569]">
                            {policy.currencyCode}{" "}
                            {formatCurrency(policy.sumInsuredAmount)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="hover:bg-gray-50">
                        <td className="p-4 border-b text-[#475569]">
                          {formatInsuranceType(insuranceData.insuranceType)}
                        </td>
                        <td className="p-4 border-b text-[#475569]">
                          {insuranceData.existingPolicy.provider}
                        </td>
                        <td className="p-4 border-b text-[#475569]">
                          {insuranceData.existingPolicy.policyExpireAt}
                        </td>
                        <td className="p-4 border-b text-[#475569]">
                          {insuranceData.existingPolicy.currencyCode}{" "}
                          {formatCurrency(
                            insuranceData?.existingPolicy?.sumInsuredAmount
                          )}
                        </td>
                      </tr>
                    )
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        className="text-center p-4 text-[#475569] font-medium border-b"
                      >
                        No Existing Policy!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* Referral info block (big layout) */}
        {isReferralFunnel && (
          <>
          <div className="w-full bg-white p-4 rounded-3xl ">
            {/* Lead Ownership / Referral Company header */}
            <div className="flex justify-between items-start">
              <div className="flex items-center">
                <p className="font-bold text-2xl">
                  Referral Company
                </p>
              </div>
              {(accountOwner || canEditLead) && (
                <div className="flex space-x-2">
                  {isEditing && (
                    <button
                      className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-gray-200 transition flex items-center justify-center w-12 h-12"
                      onClick={handleCancel}
                      aria-label="Cancel Editing"
                      type="button"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18 18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  )}

                  <button
                    className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-yellow-300 transition flex items-center justify-center w-12 h-12"
                    onClick={isEditing ? handleSubmit : handleEditClick}
                    aria-label={isEditing ? "Submit" : "Edit Lead"}
                    type="button"
                  >
                    {isEditing ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m4.5 12.75 6 6 9-13.5"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                        />
                      </svg>
                    )}
                  </button>
                </div>
              )}
            </div>

            {/* Grid Container for All Rows */}
            <div className="grid grid-cols-2 gap-x-5 ml-5">
              {/* Company Name */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Company Name</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="company_name"
                      value={referralFormData.company_name || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <div className="flex-1 flex items-center">
                      <span>{leadJourney.company_name}</span>
                    </div>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.company_name);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

              {/* Hunter */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Hunter</b>
                  </span>
                  <span className="flex-1">{leadJourney.hunter_name}</span>
                  {(accountOwner && leadJourney.hunter_id === null) ? (
                    <button
                      onClick={handleAssignHunter}
                      className="text-[#5D65F8] underline hover:text-[#4A52E6] focus:outline-none mr-2 font-bold text-sm"
                    >
                      Assign Hunter
                    </button>
                  ) : null}
                </div>
              </div>

              {/* Contact Method */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Contact Method</b>
                  </span>
                  {isEditing ? (
                    <select
                      name="contact_method"
                      value={referralFormData.contact_method || ""}
                      onChange={handleChange}
                      className={selectClass(referralFormData.contact_method, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Contact Method</option>
                      {Object.entries(contactMethodMap).map(([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="flex-1">
                      {contactMethodMap[leadJourney.contact_method] || leadJourney.contact_method}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Lead Source</b>
                  </span>
                  <span className="flex-1">{leadJourney.lead_source}</span>
                </div>
              </div>
            

            <div className="flex items-center mt-5 mb-2">
              <p className="font-bold text-2xl w-full pt-4">
                Referral Details
              </p>
            </div>

            <br />

            {/* Name */}
            <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Name</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <div className="flex-1 flex items-center gap-2">
                      <select
                        name="salutation"
                        value={referralFormData.salutation || ""}
                        onChange={handleChange}
                        className={selectClass(referralFormData.salutation, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                      >
                        <option value="">Select</option>
                        {Object.entries(salutationMap).map(([key, label]) => (
                          <option key={key} value={key}>
                            {label}
                          </option>
                        ))}
                      </select>
                      <input
                        type="text"
                        name="name"
                        value={referralFormData.name || ""}
                        onChange={handleChange}
                        className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                      />
                    </div>
                  ) : (
                    <span className="flex-1">
                      {(() => {
                        const salutation = referralFormData.salutation ? salutationMap[referralFormData.salutation] : (leadJourney.salutation ? salutationMap[leadJourney.salutation] : "");
                        const name = referralFormData.name || leadJourney.name || "";
                        return salutation ? `${salutation} ${name}` : name;
                      })()}
                    </span>
                  )}
                  <button
                    onClick={() => {
                      const salutation = referralFormData.salutation ? salutationMap[referralFormData.salutation] : (leadJourney.salutation ? salutationMap[leadJourney.salutation] : "");
                      const name = referralFormData.name || leadJourney.name || "";
                      const fullName = salutation ? `${salutation} ${name}` : name;
                      navigator.clipboard.writeText(fullName);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Email</b>
                  </span>
                  {isEditing ? (
                    <input
                      type="email"
                      name="email"
                      value={referralFormData.email || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                      placeholder="example@email.com"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.email}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.email);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

            {/* Mobile (Personal) */}
            <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Mobile (Personal)</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <div className="flex-1 flex gap-2">
                      <select
                        name="mobile_country_code"
                        value={referralFormData.mobile_country_code || "+60"}
                        onChange={handleChange}
                        className={selectClass(referralFormData.mobile_country_code, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                      >
                        {countryCodes.map((code) => (
                          <option key={code.value} value={code.value}>
                            {code.value}
                          </option>
                        ))}
                      </select>
                      <input
                        type="tel"
                        name="mobile_no"
                        value={referralFormData.mobile_no || ""}
                        onChange={handleChange}
                        placeholder="Enter phone number"
                        className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                      />
                    </div>
                  ) : (
                    <span className="flex-1">
                      {referralFormData.mobile_country_code && referralFormData.mobile_no
                        ? `${referralFormData.mobile_country_code}${referralFormData.mobile_no}`
                        : leadJourney.mobile_no || ""}
                    </span>
                  )}
                  <button
                    onClick={() => {
                      const mobileToCopy = referralFormData.mobile_country_code && referralFormData.mobile_no
                        ? `${referralFormData.mobile_country_code}${referralFormData.mobile_no}`
                        : leadJourney.mobile_no;
                      navigator.clipboard.writeText(mobileToCopy);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Phone (Office)</b>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="office_no"
                      value={referralFormData.office_no || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.office_no}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.office_no);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Position</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <div className="flex-1 flex gap-2">
                      <input
                        name="designation"
                        value={referralFormData.designation || ""}
                        onChange={handleChange}
                        placeholder="Manager, Founder ect."
                        className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                      />
                    </div>
                  ) : (
                    <span className="flex-1">{leadJourney.designation}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.designation);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

           {/* Language(s) */}
              <div className=" flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Language(s)</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <div className="flex-1 flex flex-wrap gap-3">
                      {Object.entries(languageMap).map(([key, label]) => (
                        <label key={key} className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={(referralFormData.languages || []).includes(key)}
                            onChange={() => handleLanguageChange(key)}
                            className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                          />
                          <span className="text-sm">{label}</span>
                        </label>
                      ))}
                    </div>
                  ) : (
                    <span className="flex-1">
                      {referralFormData.languages && referralFormData.languages.length > 0
                        ? referralFormData.languages.map(key => languageMap[key]).filter(Boolean).join(', ')
                        : leadJourney.language || ""}
                    </span>
                  )}
                </div>
              </div>

              {/* Nature of Business and Industry */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Nature of Business</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <select
                      name="nature_of_business"
                      value={referralFormData.nature_of_business || ""}
                      onChange={handleChange}
                      className={selectClass(referralFormData.nature_of_business, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Nature of Business</option>
                      {Object.entries(natureOfBusinessMap).map(([key, label]) => (
                        <option key={key} value={key}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="flex-1">
                      {natureOfBusinessMap[leadJourney.nature_of_business] || leadJourney.nature_of_business}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Industry</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <select
                      name="industry"
                      value={referralFormData.industry || ""}
                      onChange={handleChange}
                      className={selectClass(referralFormData.industry, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Industry</option>
                      {Object.entries(industryMap).map(([key, label]) => (
                        <option key={key} value={key}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="flex-1">
                      {industryMap[leadJourney.industry] || leadJourney.industry}
                    </span>
                  )}
                </div>
              </div>

              {/* Relationship Strength */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Relationship Strength</b>
                  </span>
                  {isEditing ? (
                    <select
                      name="interest_level"
                      value={relationshipStrengthNumericMap[referralFormData.interest_level] || ""}
                      onChange={handleRelationshipStrengthChange}
                      className={selectClass(relationshipStrengthNumericMap[referralFormData.interest_level], "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Relationship Strength</option>
                      {Object.entries(relationshipStrengthSelectMap).map(([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    // <span className="flex-1">{leadJourney.interest_level}</span>
                    <span className="flex-1 inline-flex items-center">
                      {icon} <span className="ml-1">{label}</span>
                    </span>
                  )}
                </div>
              </div>

              {/* Street */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Street</b>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="street"
                      value={referralFormData.street || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.street}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.street);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

              {/* City */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>City</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="city"
                      value={referralFormData.city || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.city}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.city);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

              {/* Post Code */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Post Code</b>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="postal_code"
                      value={referralFormData.postal_code || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">
                      {leadJourney.postal_code}
                    </span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.postal_code);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

              {/* State */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>State</b>
                  </span>
                  {isEditing ? (
                    <input
                      type="text"
                      name="state"
                      value={referralFormData.state || ""}
                      onChange={handleChange}
                      className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                    />
                  ) : (
                    <span className="flex-1">{leadJourney.state}</span>
                  )}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(leadJourney.state);
                      toast.success("Copied to clipboard!");
                    }}
                    className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <img src="/icons/content_copy.svg" className="size-6" />
                  </button>
                </div>
              </div>

              {/* Region/Country */}
              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex">
                  <span className="w-1/3">
                    <b>Region/Country</b> <a className="text-[#DD3730]">*</a>
                  </span>
                  {isEditing ? (
                    <select
                      name="region"
                      value={referralFormData.region || ""}
                      onChange={handleChange}
                      className={selectClass(referralFormData.region, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Region/Country</option>
                      {Object.entries(regionCountryMap).map(([key, label]) => (
                        <option key={key} value={key}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="flex-1">
                      {regionCountryMap[leadJourney.region] || leadJourney.region || "Not Selected"}
                    </span>
                  )}
                </div>
              </div>

              <div className="flex items-start mt-5">
                <div className="border-b border-gray-200 pb-2 w-full flex items-center mb-5">
                  <span className="w-1/3">
                    <b>Race of PIC</b>
                  </span>
                  {isEditing ? (
                    <select
                      name="race_of_pic"
                      value={referralFormData.race_of_pic || ""}
                      onChange={handleChange}
                      className={selectClass(referralFormData.race_of_pic, "flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left")}
                    >
                      <option value="">Select Race</option>
                      {Object.entries(raceOfPicMap).map(([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span className="flex-1">
                      {raceOfPicMap[leadJourney.race_of_pic] || leadJourney.race_of_pic}
                    </span>
                  )}
                </div>
              </div>

              {/* Conditionally render the "If Others, Specify" field */}
              {referralFormData.race_of_pic === "Others" && (
                <div className="flex items-start mt-5">
                  <div className="border-b border-gray-200 pb-2 w-full flex items-center mb-5">
                    <span className="w-1/3">
                      <b>If Others, Specify</b>
                    </span>
                    {isEditing ? (
                      <input
                        type="text"
                        name="race_of_pic_others"
                        value={referralFormData.race_of_pic_others || ""}
                        onChange={handleChange}
                        className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                      />
                    ) : (
                      <span className="flex-1">
                        {leadJourney.race_of_pic_others}
                      </span>
                    )}
                  </div>
                </div>
              )}
              </div>

            {/* Referrer Bank Details (Referral only) */}
            {(oppData.funnel === "Referral") && (
              <>
               {/* && leadJourney.lead_source !=='Referral Active' */}
                <div className="flex justify-between items-start mt-5 mb-2">
                  <div className="flex items-center">
                    <p className="font-bold text-2xl pt-4">
                      Referrer Bank Details
                    </p>
                  </div>
                  {accountOwner && (
                    <div className="flex space-x-2">
                      {isEditingBankDetails && (
                        <button
                          className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-gray-200 transition flex items-center justify-center w-12 h-12"
                          onClick={handleBankDetailsCancel}
                          aria-label="Cancel Editing"
                          type="button"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="size-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M6 18 18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      )}
                    </div>
                  )}
                </div>
                <br />

                {/* Grid Container for Bank Details */}
                <div className="grid grid-cols-2 gap-x-5 ml-5">
                  {/* <div className="grid grid-cols-2 gap-x-5 ml-5  items-start mb-5"> */}
                    <div className="flex items-start mt-5">
                      <div className="border-b border-gray-200 pb-2 w-full flex">
                        <span className="w-1/3">
                          <b>Lead Owner</b>
                        </span>
                        <span className="flex-1">{leadJourney.hunter_name}</span>
                      </div>
                    </div>
                    <div className="flex items-start mt-5">
                      <div className="border-b border-gray-200 pb-2 w-full flex">
                        <span className="w-1/3">
                          <b>Referrer Name</b>
                        </span>
                        {isEditing ? (
                          <input
                            type="text"
                            name="referrer_name"
                            value={referralFormData.referrer_name || ""}
                            onChange={handleChange}
                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                          />
                        ) : (
                          <div className="flex-1 flex items-center">
                            <span>{leadJourney.referrer_name}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="flex items-start mt-5">
                      <p className="border-b border-gray-200 pb-2 w-full flex">
                        <span className="w-1/3">
                          <b>Referrer Company</b>
                        </span>
                        {isEditing ? (
                          <input
                            type="text"
                            name="referrer_company"
                            value={referralFormData.referrer_company || ""}
                            onChange={handleChange}
                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                          />
                        ) : (
                          <div className="flex-1 flex items-center">
                            <span>{leadJourney.referrer_company}</span>
                          </div>
                        )}
                      </p>
                    </div>

                    <div className="flex items-start mt-5">
                      <div className="border-b border-gray-200 pb-2 w-full flex">
                        <span className="w-1/3">
                          <b>Referrer Contact</b>
                        </span>
                        {isEditing ? (
                          <input
                            type="text"
                            name="referrer_contact"
                            value={referralFormData.referrer_contact || ""}
                            onChange={handleChange}
                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                          />
                        ) : (
                          <div className="flex-1 flex items-center">
                            <span>{leadJourney.referrer_contact}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="flex items-start mt-5">
                      <div className="border-b border-gray-200 pb-2 w-full flex">
                        <span className="w-1/3">
                          <b>Referrer Email</b>
                        </span>
                        {isEditing ? (
                          <input
                            type="text"
                            name="referrer_email"
                            value={referralFormData.referrer_email || ""}
                            onChange={handleChange}
                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                          />
                        ) : (
                          <div className="flex-1 flex items-center">
                            <span>{leadJourney.referrer_email}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="flex items-start mt-5">
                      <div className="border-b border-gray-200 pb-2 w-full flex">
                        <span className="w-1/3">
                          <b>Referrer Code</b>
                        </span>
                        {isEditing ? (
                          <input
                            type="text"
                            name="referrer_code"
                            value={referralFormData.referrer_code || ""}
                            onChange={handleChange}
                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                          />
                        ) : (
                          <div className="flex-1 flex items-center">
                            <span>{leadJourney.referrer_code}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Bank Name & Account Number */}
                    <div className="flex items-start mt-5">
                      <div className='border-b border-gray-200 pb-2 w-full flex'>
                          <span className="w-1/3"><b>Bank Name</b></span>
                          {isEditing ? (
                              <input
                                  type="text"
                                  name="referrer_bank_name"
                                  value={referralFormData.referrer_bank_name || ''}
                                  onChange={handleChange}
                                  className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                              />
                          ) : (
                              <span className="flex-1">{leadJourney.referrer_bank_name}</span>
                          )}
                          <button
                              onClick={() => {
                                  navigator.clipboard.writeText(leadJourney.referrer_bank_name);
                                  toast.success('Copied to clipboard!');
                              }}
                              className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                              >
                                  <img src="/icons/content_copy.svg" className='size-6'/>
                          </button>
                      </div>
                    </div>
                    <div className="flex items-start mt-5">
                      <div className='border-b border-gray-200 pb-2 w-full flex'>
                          <span className="w-1/3"><b>Bank Account Name</b></span>
                          {isEditing ? (
                              <input
                                  type="text"
                                  name="referrer_bank_acc_name"
                                  value={referralFormData.referrer_bank_acc_name || ''}
                                  onChange={handleChange}
                                  className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                              />
                          ) : (
                              <span className="flex-1">{leadJourney.referrer_bank_acc_name}</span>
                          )}
                          <button
                              onClick={() => {
                                  navigator.clipboard.writeText(leadJourney.referrer_bank_acc_name);
                                  toast.success('Copied to clipboard!');
                              }}
                              className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                              >
                                  <img src="/icons/content_copy.svg" className='size-6'/>
                          </button>
                      </div>
                    </div>
                    <div className="flex items-start mt-5">
                      <div className='border-b border-gray-200 pb-2 w-full flex'>
                          <span className="w-1/3"><b>Bank Account Number</b></span>
                          {isEditing ? (
                              <input
                                  type="text"
                                  name="referrer_bank_acc_no"
                                  value={referralFormData.referrer_bank_acc_no || ''}
                                  onChange={handleChange}
                                  className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                              />
                          ) : (
                              <span className="flex-1">{leadJourney.referrer_bank_acc_no}</span>
                          )}
                          <button
                              onClick={() => {
                                  navigator.clipboard.writeText(leadJourney.referrer_bank_acc_no);
                                  toast.success('Copied to clipboard!');
                              }}
                              className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                              >
                                  <img src="/icons/content_copy.svg" className='size-6'/>
                          </button>
                      </div>
                    </div>
                </div>
              </>
            )}
          </div>
          </>
        )}
      </div>

      {/* Assign Hunter Function (Select Hunter Modal & Confirm Hunter Modal) */}
      {showAssignHunter && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-1/3">
            <span className="flex-1 -ml-1 inline-flex items-center">

              <h2 className="text-xl font-bold mb-1">
                Assign To Hunter
              </h2>
            </span>
            <p className="border-b border-gray-200 w-full flex mb-4"></p>

            {/* <p>Current lead owner</p>
            <input
              type="text"
              className="w-full p-2 border border-gray-300 rounded mb-4 mt-1 bg-gray-100"
              value={leadJourney.hunter_name}
              readOnly
            /> */}

            <p>Assign to</p>
            <select
              className="w-full p-2 border border-gray-300 rounded mb-4 mt-1"
              value={selectedHunter}
              onChange={(e) => setSelectedHunter(e.target.value)}
            >
              <option value="">Select from list</option>
              {hunterListAPI.map((hunter) => (
                <option key={hunter.id} value={hunter.username}>
                  {hunter.username}
                </option>
              ))}
            </select>
            <div className="flex justify-end space-x-2">
              <button
                className="bg-white text-black py-3 px-4 rounded-3xl border-[1px] border-black hover:bg-gray-100"
                onClick={() => setShowAssignHunter(false)}
              >
                <b>Cancel</b>
              </button>
              <button
                className="bg-yellow-300 text-black py-3 px-8 rounded-3xl hover:bg-yellow-400"
                onClick={() => setShowAssignHunterConfirmationModal(true)}
              >
                <b>Continue</b>
              </button>
            </div>
          </div>
        </div>
      )}
      { showAssignHunterConfirmationModal && (
        <div className="fixed z-[60] inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
          <div className="bg-white p-6 rounded-lg w-1/4">
            {/* Center the icon using Flexbox */}
            <div className="flex justify-center mb-2 pt-6">
              <img src="/icons/edit.svg" className="size-11" />
            </div>

            <h1 className="text-2xl font-bold mb-3">Save & Update Owner</h1>
            <p>
              Lead is going to be passed to <b>{selectedHunter}</b>. Please
              ensure selected hunter <b>({selectedHunter})</b> are correct.
            </p>
            <div className="mt-6 mb-6">
              <button
                className="text-black underline hover:text-blue-800 focus:outline-none"
                onClick={() => setShowAssignHunterConfirmationModal(false)}
              >
                <b>No, Don't Update</b>
              </button>
            </div>
            <button
              className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400"
              // TODO: add the confirmation submit for assign hunter
              onClick={handleHunterAssignSubmit}
            >
              <b>Save & Update</b>
            </button>
          </div>
        </div>
      )}

      {/* Information Gathering for Financing Confirmation Modal */}
      {showFinancingConfirmationModal && (
        <div className="fixed inset-0 z-[60] bg-black bg-opacity-50 flex items-center justify-center text-center">
          <div className="bg-white p-6 rounded-lg w-1/4">
            <div className="flex justify-center mb-2 pt-6">
              <img src="/icons/edit.svg" className="size-11" />
            </div>

            <h1 className="text-2xl font-bold mb-3">
              Save &amp; Update Info Gathering for Financing
            </h1>
            <p>
              Info Gathering details will be updated. Please ensure new details
              are correct.
            </p>
            <div className="mt-6 mb-6">
              <button
                className="text-black underline hover:text-gray-600 focus:outline-none"
                onClick={handleConfirmationCancel}
                type="button"
              >
                <b>No, Don&apos;t Update</b>
              </button>
            </div>
            <button
              className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400"
              onClick={handleConfirmation}
              type="button"
            >
              <b>Save &amp; Update</b>
            </button>
          </div>
        </div>
      )}
      
      {/* Information Gathering for Referral Confirmation Modal */}
      {showReferralConfirmationModal && (
        <>
        <div className="fixed inset-0 z-[60] bg-black bg-opacity-50 flex items-center justify-center text-center">
          <div className="bg-white p-6 rounded-lg w-1/2">
          {submissionLoading && (
                  <div className="absolute inset-0 bg-white bg-opacity-90 flex items-center justify-center rounded-lg w-auto">
                      <div className="text-center">
                          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
                          <p className="text-lg font-semibold">Updating Details ...</p>
                          <p className="text-gray-600">Please wait while we process the update</p>
                      </div>
                  </div>
            )}
            {uploadStatus === 'success' && (
                <div className="absolute inset-0 bg-white bg-opacity-95 flex items-center justify-center rounded-lg">
                    <div className="text-center">
                        <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-green-100 flex items-center justify-center">
                            <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                        </div>
                        <p className="text-lg font-semibold text-green-600">Details Successfully Updated</p>
                    </div>
                </div>
            )}
            
            {uploadStatus === 'error' && (
                <div className="absolute inset-0 bg-white bg-opacity-95 flex items-center justify-center rounded-lg">
                    <div className="text-center">
                        <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-red-100 flex items-center justify-center">
                            <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </div>
                        <p className="text-lg font-semibold text-red-600">Failed upload details</p>
                        <p className="text-gray-600">Please try again or contact support</p>
                        <button
                            className="mt-4 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                            onClick={() => setUploadStatus(null)}
                        >
                            Try Again
                        </button>
                    </div>
                </div>
            )}
            <div className="flex justify-center mb-2 pt-6">
              <img src="/icons/edit.svg" className="size-11" />
            </div>

            <h1 className="text-2xl font-bold mb-3">
              Save &amp; Update Info Gathering for Referral
            </h1>
            <p>
              <b>{leadJourney.company_name}</b> details will be updated. Please ensure new details
              are correct.
            </p>
            <div className="mt-6 mb-6">
              <button
                className="text-black underline hover:text-gray-600 focus:outline-none"
                onClick={handleConfirmationCancel}
                type="button"
              >
                <b>No, Don&apos;t Update</b>
              </button>
            </div>
            <button
              className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400"
              onClick={handleConfirmation}
              type="button"
            >
              <b>Save &amp; Update</b>
            </button>
          </div>
        </div>
        </>
      )}

      {/* Bank Details Confirmation Modal */}
      {showBankDetailsConfirmationModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
          <div className="bg-white p-6 rounded-lg w-1/4">
            <div className="flex justify-center mb-2 pt-6">
              <img src="/icons/edit.svg" className="size-11" />
            </div>

            <h1 className="text-2xl font-bold mb-3">
              Save &amp; Update Bank Details
            </h1>
            <p>
              Referrer bank details will be {referrerData ? "updated" : "created"}. Please ensure new details
              are correct.
            </p>
            <div className="mt-6 mb-6">
              <button
                className="text-black underline hover:text-gray-600 focus:outline-none"
                onClick={handleBankDetailsConfirmationCancel}
                type="button"
              >
                <b>No, Don&apos;t Update</b>
              </button>
            </div>
            <button
              className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400"
              onClick={handleBankDetailsConfirmation}
              type="button"
            >
              <b>Save &amp; Update</b>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default OpportunityInfoTab;